import React from "react";

export const ShortArrowGrayReversed = () =>
  <svg width="14" height="48" viewBox="0 0 14 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 48L7 9" stroke="#6C707E" stroke-width="2"/>
    <path d="M7 0L11.3301 9.75L2.66987 9.75L7 0Z" fill="#6C707E"/>
  </svg>
